import { render, staticRenderFns } from "./collectPolicy.vue?vue&type=template&id=0017b7f4&scoped=true"
import script from "./collectPolicy.vue?vue&type=script&lang=js"
export * from "./collectPolicy.vue?vue&type=script&lang=js"
import style0 from "./collectPolicy.vue?vue&type=style&index=0&id=0017b7f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0017b7f4",
  null
  
)

export default component.exports